import { isValidPhoneNumber } from 'libphonenumber-js';

import type { Address } from '~/stores/address/types';
import type { Country } from '~/stores/app/types';

export enum AddressType {
  BILLING = 'billing',
  SHIPPING = 'shipping',
}

export type CountryLabel = keyof Omit<Country, 'currency_iso_code' | 'iso_code' | 'phone_number'>;

export const validateAddress = (address: Address): boolean => {
  const { city, phone, postal_code, street } = address;

  const isPhoneValid = phone ? isValidPhoneNumber(phone) : true;

  return !!(street && postal_code && city) && isPhoneValid;
};

export const getCountryName = (country: Country, locale: string): string | undefined => {
  return country[locale.slice(0, 2) as CountryLabel];
};

export const isCountryWithState = (countryCode: string): boolean => /^(US|CA|AU|IN|MX|BR|DE|AR)$/.test(countryCode);
